import React from 'react'
import Header from '../../Header'
import Sidebar from '../../Sidebar'
import FeatherIcon from 'feather-icons-react/build/FeatherIcon'
import { Link } from 'react-router-dom'
import { doctor03, female, male } from '../../imagepath'
import { useAuth } from '../../../services/authentication_API/authService'

const Pharmacy_Profile = () => {
  const {  userData } = useAuth();

  return (
    <>
    <Header/>
    <Sidebar/>
    <>
    <div className="page-wrapper">
  <div className="content">
    <div className="row">
      <div className="col-sm-7 col-6">
        <ul className="breadcrumb">
          <li className="breadcrumb-item"><Link to="/pharmacy-dashboard">Pharmacy Dashboard </Link></li>
          <li className="breadcrumb-item">
            <i className="feather-chevron-right">
              <FeatherIcon icon="chevron-right"/>
              </i>
            </li>
        <li className="breadcrumb-item active">My Profile</li>
        </ul>
      </div>
    </div>
    <div className="card-box profile-header">
      <div className="row">
        <div className="col-md-12">
          <div className="profile-view">
            <div className="profile-img-wrap">
              <div className="profile-img">
                <Link to="#"><img className="avatar" src={userData?.gender=="Male" ? male : female} alt="#" /></Link>
              </div>
            </div>
            <div className="profile-basic">
              <div className="row">
                <div className="col-md-5">
                  <div className="profile-info-left">
                    <h3 className="user-name m-t-0 mb-0">{userData?.name}{""}{userData?.last_name} </h3>
                    <div className="staff-id">Receptionist ID : {userData?.id}</div>
                  </div>
                </div>
                <div className="col-md-7">
                  <ul className="personal-info">
                    <li>
                      <span className="title">Phone:</span>
                      <span className="text"><Link to>{userData?.mobile || "-"}</Link></span>
                    </li>
                    <li>
                      <span className="title">Email:</span>
                      <span className="text"><Link to>{userData?.email || "-"}</Link></span>
                    </li>
                    <li>
                      <span className="title">Birthday:</span>
                      <span className="text">{userData?.date_of_birth || "-"}</span>
                    </li>
                    <li>
                      <span className="title">Address:</span>
                      <span className="text">{userData?.address || "-"}</span>
                    </li>
                    <li>
                      <span className="title">Gender:</span>
                      <span className="text">{userData?.gender || "-"}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>                        
        </div>
      </div>
    </div>
  </div>
</div>

    </>
    </>
  )
}

export default Pharmacy_Profile
